import { createFileRoute } from '@tanstack/react-router';

import { BoardReportPage } from '@/features/nis2/components/board-report/BoardReportPage';

export const Route = createFileRoute('/_authenticated/nis2/reports/board')({
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <div className="min-h-screen bg-background p-8">
      <div className="mx-auto max-w-7xl">
        <BoardReportPage />
      </div>
    </div>
  );
}
